import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-tenant",
  templateUrl: "./tenant.component.html",
  standalone: false,
})
export class TenantComponent implements OnInit {
  longLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {}

  async ngOnInit() {
    setTimeout(() => (this.longLoading = true), 10000);

    try {
      const adminConsent = this.route.snapshot.queryParams.admin_consent as
        string | undefined;
      const tenant = this.route.snapshot.queryParams.tenant as
        string | undefined;

      if (adminConsent === "True" && tenant) {
        await this.saveTenant(tenant);
      }
    } catch {
      // Ignore errors
    }

    await this.router.navigate(["/settings/integration"]);
  }

  private async saveTenant(tenantId: string): Promise<void> {
    await this.http
      .post(`/microsoft/tenant`, {
        tenantId,
      })
      .toPromise();
  }
}
